<template>
  <div class="connection-line-statement" v-bind:class="{ empty: text === undefined }" >
    <div class="connection-button" @click="click()"><svgicon icon="edit" width="32" height="32" color="#334274" v-if="text === undefined"></svgicon></div>
    <div class="connection-button" @click="click()"><svgicon icon="note" width="32" height="32" color="#334274" v-if="text !== undefined && open === false"></svgicon></div>
    <div class="connection-button" @click="click()"><svgicon icon="close" width="32" height="32" color="#334274" v-if="text !== undefined && open !== false"></svgicon></div>
    <div class="connection-line-statement--inner" v-if="open">
      <blur-editable :content="text" @change="change($event)" ref="editableStatement"></blur-editable>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import BlurEditable from '@/components/BlurEditable' // eslint-disable-line

var db = firebase.database()
var projectsRef = db.ref('projects')

export default {
  name: 'ConnectionLineStatement',
  props: ['statement', 'statementLine'],
  components: {
    BlurEditable
  },
  data () {
    return {
      open: false,
      addEditable: false,
      text: this.statement
    }
  },
  methods: {
    change (input) {
      projectsRef.child(this.statementLine.project).child('items').child(this.statementLine.origin).child('origins').child(this.statementLine.target).child('statement').set(input)
      this.text = input
      this.$emit('statementChange', input)
      if (this.text === '' || this.text === '\n' || this.text === 'Begründung…') {
        projectsRef.child(this.statementLine.project).child('items').child(this.statementLine.origin).child('origins').child(this.statementLine.target).child('statement').remove()
      }
    },
    click () {
      // Schließen
      if (this.open) {
        if (this.text !== undefined && (this.text === '' || this.text === '\n' || this.text === 'Begründung…')) {
          projectsRef.child(this.statementLine.project).child('items').child(this.statementLine.origin).child('origins').child(this.statementLine.target).child('statement').remove()
          this.text = undefined
        } else {
          projectsRef.child(this.statementLine.project).child('items').child(this.statementLine.origin).child('origins').child(this.statementLine.target).child('statement').set(this.text)
        }
        this.$emit('statementChange', this.text)
        this.open = false
        return
      }

      // Öffnen
      if (this.text !== undefined && this.open === false) {
        this.open = true
        return
      }

      // Hinzufügen
      if (this.text === undefined && this.open === false) {
        this.text = 'Begründung…'
        this.open = true
      }
    }
  }
}
</script>

<style lang="scss">
  .connection-line-statement {
    transform: rotate(-90deg);
    box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
    width: 48px;
    height: 48px;
    position: absolute;
    top: 50%;
    right: 28px;
    margin-left: -24px;
    margin-top: -24px;
    background: rgba(#fff, 0.9);
    border-radius: 50%;
    text-align: center;
    line-height: 46px;
    z-index: 100;
    &.empty {
      width: 24px;
      height: 24px;
      line-height: 24px;
      // left: 24px;
      margin-top: -12px;
      margin-left: 10px;
      .connection-button {
        svg {
          width: 24px !important;
          height: 24px !important;
          margin-top: -2px;
        }
      }
    }
    &:not(.empty) {
      right: 18px;
      background: rgba($color-action,0.9);
      svg path {
        fill: #fff;
      }
    }
  }
  .connection-button {
    cursor: pointer;
  }
  .connection-line-statement--inner {
    left: 50%;
    width: 180px;
    min-height: 49px;
    font-size: $font-size-small;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.2);
    border-bottom: 3px solid rgba($color-action,0.25);
    margin-left: -90px;
    box-sizing:border-box;
    padding: 15px;
    position: absolute;
    border-radius: 2px;
    background-color: #fff;
    line-height: 1.4em;
    &:before {
      content: " ";
      position: absolute;
      left: 50%;
      top: -5px;
      margin-left: -4px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConnectionLineStatement.vue